import styled from "styled-components";

import UpdateButton from "@EditArticleContainer/shared/components/UpdateButton/UpdateButton";

export const ParagraphCompetitiveLandscapeUpdateButton = styled(UpdateButton)`
  position: absolute;
  top: 50%;
  left: -1.6rem;
  transform: translateY(-50%) translateX(-100%);
`;

export const ParagraphDrugProfileUpdateButton = styled(UpdateButton)`
  position: absolute;
  top: 0.8rem;
  left: -1.6rem;
  transform: translateX(-100%);
`;

export const DrugProfileTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  .is-hide-drug-profile-row-true {
    display: none;
  }
`;
